// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tooltip_wrapper__OAnSk","content":"tooltip_content__hymmG","show":"tooltip_show__3-SkW","tooltipable":"tooltip_tooltipable__5WLnD"};